/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Typography2, typography2, useTheme } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';
import { StarFilledIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/xdp';

type Size = 'small' | 'large';

type Props = {
  rating?: number | null;
  ratingCount?: number | null;
  size?: Size;
};

const styles = {
  rating: (theme: Theme, size: Size) => css`
    display: inline-flex;
    align-items: center;
    padding-right: ${theme.spacing(8)};
    ${size === 'small' ? typography2.subtitleMedium : theme.typography.h2semibold};
    color: ${theme.palette.black[500]};
  `,
  starIcon: (theme: Theme) => css`
    padding-left: ${theme.spacing(4)};
  `,
};

const Rating = ({ rating, ratingCount, size = 'small' }: Props) => {
  const theme = useTheme();

  const iconSize = size === 'small' ? 'medium' : 'large';

  if (!rating) {
    return null;
  }

  return (
    <span>
      <span css={styles.rating(theme, size)}>
        {rating.toFixed(1)} <StarFilledIcon size={iconSize} color="interactive" css={styles.starIcon} />
      </span>
      {Boolean(ratingCount) && ratingCount && (
        <Typography2 variant="bodySecondary" component="span" color="supportText">
          (
          <FormattedMessage
            message={_t('{ratingCount, plural, =1 {{ratingCount} rating} other {{ratingCount} ratings}}')}
            ratingCount={ratingCount.toLocaleString()}
          />
          )
        </Typography2>
      )}
    </span>
  );
};
export default Rating;
